<!-- 数据曲线 -->
<template>
    <div class='container containerBox'>
        <div class="handleForm" ref="handleForm">
            <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="集控器">
                    <el-select v-model="form.collector" placeholder="请选择集控器" @change="handleChageCollect">
                        <el-option
                            v-for="item in collectorList"
                            :key="item.oid"
                            :label="item.dev_name"
                            :value="item.oid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备">
                    <el-select v-model="form.device" placeholder="请选择设备" @change="handleChagePlc">
                        <el-option
                            v-for="item in deviceList"
                            :key="item.oid"
                            :label="item.device_model+'：'+item.terminal_serial"
                            :disabled="item.dev_type != 4"
                            :value="item.oid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间范围">
                    <el-date-picker
                        v-model="form.time"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="choseTime">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="时间间隔">
                    <el-select v-model="form.timeInterval" placeholder="请选择时间间隔">
                        <el-option
                            v-for="item in timeInterval"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleTabClick">
            <el-tab-pane label="温度曲线" name="2">
                <div class="echart-box">
                    <div id="main_t" class="main" ref="myEchart_t" style="width: 100%;height:400px"></div>
                </div>
                <div class="nodata" v-show="getPlcCurve.length===0">
                    --  暂无数据 --
                </div>
            </el-tab-pane>
            <el-tab-pane label="压力曲线" name="1">
                <div class="echart-box">
                    <div id="main_y" class="main" ref="myEchart_y" style="width: 100%;height:400px"></div>
                </div>
                <div class="nodata" v-show="getPlcCurve.length===0">
                    --  暂无数据 --
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import echarts from "echarts"
import Service from '@/api/Service'
import { FormatDate, FormatPrevDate, computedUtil2, FormatUTCDate } from '@/utils/utils'

const nowDay = FormatDate("yyyy-MM-dd HH:mm:ss");
const prevDay = FormatPrevDate("yyyy-MM-dd HH:mm:ss");
const SETTING_TYPE = 2;
const timeInterval = [
    {
        value: 1,
        name: '分钟'
    },
    {
        value: 2,
        name: '小时'
    },
    {
        value: 3,
        name: '天'
    },
    {
        value: 4,
        name: '周'
    },
    {
        value: 5,
        name: '月'
    },
    {
        value: 7,
        name: '年'
    },
]
export default {
    name:  'DeviceCurve',
    data() {
        return {
            chart_y: null,
            chart_x: null,
            activeName: "2",

            form: {
                time: [],
                start_time: prevDay,
                end_time: nowDay,
                device: '',
                collector: '',
                timeInterval: 2,
            },

            collectorList: [], // 集控器列表
            deviceList: [], // 设备列表
            pageConfigList: [],  // 页面变量配置
            getPlcCurve: [],    // 变量值

            temp_config: [],
            pressure_config: [],

            page_num: 1,
            page_sum: 5,

            timeInterval: timeInterval,
        };
    },

    components: {},

    computed: {
        ...mapGetters(["machine"]),
    },
    mounted() {
        this.$nextTick(() => {
            // this.chartConfig_x();
            this.chart_x = echarts.init(this.$refs.myEchart_t); //这里是为了获得容器所在位置
        })
    },
    created() {
        this.getList()
    },

    beforeDestroy() {
        if (!this.chart) {
            return;
        }
        this.chart_y.dispose();
        this.chart_y = null;
        this.chart_x.dispose();
        this.chart_x = null
    },
    methods: {
        // 获取集控器列表
        async getList() {
            if(this.machine.collect.length>0) {
                let data = this.machine.collect
                this.collectorList = data;
                this.form.collector = data[0].oid;
                this.getDeviceList(data[0]);
                return
            }
            
            let data = await Service.getCollector();
            if(data){
                data = data === 'success' ? [] : data;
                this.collectorList = data;
                this.form.collector = data[0].oid;
                this.getDeviceList(data[0]);

                this.$store.dispatch('setCollect', data);
            }
        },
        async getDeviceList(obj) {
            if(this.machine.devices.length>0){
                let list = this.machine.devices
                this.deviceList = list;
                this.form.device = list[0].oid;
                await this.getPlcConfigData()
                await this.getServerRoombypid();
                this.getPlcData(Number(this.activeName));
                return
            }
            
            let { oid } = obj
            let { page_num, page_sum } = this;
            let params = Object.assign({}, { page_num, page_sum }, {oid: oid});
            let data = await Service.getMeter(params);
            
            if(data) {
                let list = data.list == null ? [] : data.list;
                this.deviceList = list;
                if(list.length>0) {
                    this.form.device = list[0].oid;
                    this.$store.dispatch('setDevices', list);
                     // 获取设备统计数据
                    await this.getPlcConfigData()
                    await this.getServerRoombypid();
                    this.getPlcData(Number(this.activeName));
                }
            }
        },
        async getPlcConfigData() {
            if(this.machine.var_config.length>0){
                this.pageConfigList = this.machine.var_config
                return
            }
            let terminal_id = this.form.device
            let params = {
                terminal_id,
                page_num: 1,
                page_sum: 1000,
            }
            let res = await Service.getPlcConfig(params);
            if(res) {
                this.pageConfigList = res.list;
                this.$store.dispatch('setVarConfig', res.list);
            }
        },
        handleChageCollect(val) {
            this.getDeviceList({oid: val})
        },
        handleChagePlc(val) {

        },
        // 获取温度，压力配置
        async getServerRoombypid() {
            if(this.machine.temp_config.length>0){
                let res = this.machine.temp_config
                let temp = res.filter(v => v.setting_type === 2)[0].setting_data
                let pressure = res.filter(v => v.setting_type === 1)[0].setting_data
                this.temp_config = temp ? JSON.parse(temp) : []
                this.pressure_config = pressure ? JSON.parse(pressure) : []
                return
            }
            
            let res = await Service.getServerRoombypid();
            res = res === "success" ? [] : res;
            if (res.length>0) {
                this.$store.dispatch('setTempConfig', res);
                let temp = res.filter(v => v.setting_type === 2)[0].setting_data
                let pressure = res.filter(v => v.setting_type === 1)[0].setting_data
                this.temp_config = temp ? JSON.parse(temp) : []
                this.pressure_config = pressure ? JSON.parse(pressure) : []
            }
        },
        // 获取统计数据
        async getPlcData(setting_type){
            let params = {}
                params.terminal_id = this.form.device
                params.setting_type = setting_type
                params.start_time = this.form.start_time
                params.end_time = this.form.end_time
                params.timeInterval = this.form.timeInterval

// 判断时间间隔
            let time = (new Date(this.form.end_time).getTime() - new Date(this.form.start_time).getTime())/1000
           
            let BOOL = true
            if(this.form.timeInterval === 1 && (time / 60) > 200 ) {    //  超过两百条
                BOOL = false
            }
            if(this.form.timeInterval === 2 && (time / (60 * 60)) > 100 ) { // 超过60小时
                BOOL = false
            }
            if(this.form.timeInterval === 3 && (time / (60 * 60 * 24)) > 60) {  // 超过60天
                BOOL = false
            }
            if(this.form.timeInterval === 4 && (time / (30 * 60 * 60 * 24)) > 20) { // 超过20周
                BOOL = false
            }
            if(this.form.timeInterval === 5 && (time / (7 * 30 * 60 * 60 * 24)) > 12) { // 超过12月
                BOOL = false
            }
            if(this.form.timeInterval === 7 && time >  (12 * 30 * 24 * 60 * 60) ) {
                BOOL = false
            }
            
            if(!BOOL) {
                 this.$message({
                    type: 'warn',
                    message: '查询条件范围太大，请修改时间间隔或者时间范围！'
                });
                return
            }
            let res = await Service.getPlcCurve(params);
            if(res) {
                let list = res === "success" ? [] : JSON.parse(res).data;
                this.getPlcCurve = list;
                let curveConfig = setting_type === 2 ? this.temp_config : this.pressure_config;
                this.echartsData = this.formatData(this.getPlcCurve, curveConfig);
                setting_type === 2 ? this.chartConfig_x(this.echartsData) : this.chartConfig_y(this.echartsData);
            }
        },
        formatData(list, config_data) {
            if(list.length <= 0) {
                return {
                    categories: [],
                    series: []
                }
            }
            let date_str = 'HH:mm'
            let timeInterval = this.form.timeInterval
            switch (timeInterval){
                case 1:
                    date_str = 'HH:mm'
                    break;
                case 2:
                    date_str = 'MM-dd HH'
                    break;
                case 3:
                    date_str = 'MM-dd'
                    break;
                case 4:
                    date_str = 'MM-dd'
                    break;
                case 5:
                    date_str = 'yy-MM'
                    break;
                case 6:
                    date_str = 'yy'
                    break;
                default:
                    break;
            }
            let categories = [];
            let series = [];
            config_data.map((c, i) => {
                let obj = {}
                let addr = c.addr;
                obj[addr] = []; //	将地址相同的值放到同一个数组，地址为Key
                list.map(v => {
                    if (i == 1) {
                        let date = FormatUTCDate(Date.parse(v.date), date_str);
                        categories.push(date)
                    }

                    v.data.map(v1 => {
                        if (c.addr === v1.addr) {
                            // 单位换算
                            let val = v1.val
                            let obj1 = this.pageConfigList.filter((v)=>{return v.var_Initial_addr === v1.addr})
                            val = computedUtil2(val, obj1);
                            obj[addr].push(val);
                        }
                    })
                })

                series.push({
                    name: c.label,
                    type: 'line',
                    data: obj[addr],
                })
            })
            return {
                categories,
                series
            }
        },
        chartConfig_y(data) {
            let _t = this;
            if(this.chart_y === null) {
                this.chart_y = echarts.init(this.$refs.myEchart_y); //这里是为了获得容器所在位置
            }
            window.onresize = this.chart_y.resize;
            if(data.categories.length === 0) {
                this.chart_y.clear();
                return
            }
            this.chart_y.setOption({ // 进行相关配置
                title: {
                    text: '',
                    left: 'left',
                },
                tooltip: {
                    trigger: 'axis'
                },
                xAxis: {
                    data: data.categories
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: '{value} Bar'
                    },
                    splitLine: {
                        show: false
                    }
                },
                legend: {
                    data: data.series.map(v=>{return v.name}),
                    x: 'center',
                    itemGap: 15,
                },
                toolbox: {
                    left: 'right',
                    feature: {
                        dataZoom: {
                            yAxisIndex: 'none'
                        },
                        restore: {},
                        saveAsImage: {}
                    }
                },
                // 下发滑块
                dataZoom: [{
                    start: 30,
                    end: 70
                }, {
                    type: 'inside'
                }],
                series: data.series
            })
        },
        chartConfig_x(data) {
            let _t = this;
            window.onresize = this.chart_x.resize;
            if(data.categories.length === 0) {
                this.chart_x.clear();
                return
            }
            this.chart_x.clear();
            this.chart_x.setOption({ // 进行相关配置
                title: {
                    text: '',
                    left: 'left',
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: data.series.map(v=>{return v.name}),
                    x: 'center',
                    itemGap: 15,
                },
                xAxis: {
                    data: data.categories
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: '{value} °C'
                    },
                    splitLine: {
                        show: false
                    }
                },
                toolbox: {
                    left: 'right',
                    feature: {
                        dataZoom: {
                            yAxisIndex: 'none'
                        },
                        restore: {},
                        saveAsImage: {}
                    }
                },
                // 下发滑块
                dataZoom: [{
                    start: 30,
                    end: 70
                }, {
                    type: 'inside'
                }],
                series: data.series
            })
        },

        choseTime(val) {
            // 判断所选时间间隔
            if(val) {
                this.form.start_time = val[0]
                this.form.end_time = val[1]

                let time = (new Date(val[1]).getTime() - new Date(val[0]).getTime())/1000
                if(time> 0 && time<= 3 * 60 * 60 ) {
                    // 查询分钟
                    this.form.timeInterval = 1
                }else if(time > (3 * 60 * 60) && time <= (5 * 24 * 60 * 60)) {  //  5天内用小时
                    // 查询小时
                    this.form.timeInterval = 2
                }else if(time>(5 * 24 * 60 * 60) && time <= (30 * 24 * 60 * 60)) {  
                    // 查询天
                    this.form.timeInterval = 3
                }else if(time> (30 * 24 * 60 * 60) && time <=  (7 * 30 * 24 * 60 * 60)) {
                    // 查询周
                    this.form.timeInterval = 4
                }else if(time>(7 * 30 * 24 * 60 * 60) && time <=  (12 * 30 * 24 * 60 * 60)) {
                    // 查询月
                    this.form.timeInterval = 5
                }else{
                    // 查询月
                    this.form.timeInterval = 7
                }
            }else{
                this.form.timeInterval = 2
                this.form.start_time = prevDay
                this.form.end_time = nowDay
            }
        },
        // 查询
        onSubmit() {
            this.getPlcData(Number(this.activeName));
        },
        handleTabClick(tab, event) {
            if(tab.name === "1") {
                this.getPlcData(1)
            }else {
                this.getPlcData(2)
            }
        }

    }
}

</script>
<style lang='less' scoped>

</style>